import { fetchCatalogs } from '../catalog/fetchCatalogs';
import { setMarket } from '../../slices/intl';
import { closeModal, openModal } from './modal';
import { resetPanes } from '../../slices/pane';
import { trackUIInteraction } from '../../../utils/analyticsEvents';

export const closeMarketSelector = () => closeModal();

export const selectMarketAndClose =
  (retailUnit, languageCode) => async (dispatch) => {
    trackUIInteraction('change_market', { retailUnit, languageCode });
    dispatch(resetPanes());
    await dispatch(setMarket({ retailUnit, languageCode }));
    await dispatch(fetchCatalogs());
    return dispatch(closeModal());
  };

export const openMarketSelector = () => openModal('MarketDialog', {});
